import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from './header';
import Footer from './footer';

function App() {

    const [comboData, setComboData] = useState('');
    const [error, setError] = useState('');
    const [currencyValue, setCurrencyValue] = useState(1);
    const [currencySymbol, setCurrencySymbol] = useState('₹');

    useEffect(() => {
        const intervalId = setInterval(() => {
            const cValue = sessionStorage.getItem('jmpiCurnceV');
            const cSymbol = sessionStorage.getItem('jmpiCurnceS');
            setCurrencyValue(cValue);
            setCurrencySymbol(cSymbol);
        }, 1000);
        return () => clearInterval(intervalId);
    },[]);

    

    const getComboDetails = async () => {
        try{
          const response = await axios.get('https://demo.sninfoserv.com/api/combo/');
          //console.log(response.data);
          if(response.data.status === 'success'){
            setComboData(response.data);
          }
        }catch (error) {
          setError({ error: error.message });
        }
    };
      
    useEffect(() => {
        getComboDetails();
    }, []);


    const getRandomSubset = (array, size) => {
        const shuffled = array.sort(() => 0.5 - Math.random());
        return shuffled.slice(0, size);
    };


    return (
        <div class="page-wrapper">
        <h1 class="d-none">Jampani Pickles</h1>
      
        <Header /> 
        <main class="main mb-10 pb-1">
         
         <nav class="breadcrumb-nav container">
             <ul class="breadcrumb bb-no">
                 <li><a href="/">Home</a></li>
                 <li>Combo Offers</li>
             </ul>
         </nav>
         

        <div class="page-content">
            <div class="container">
                <div class="row gutter-lg mb-10">
                    
                    <h4 align="center" class="mb-6 mt-6">Combo Offers</h4>
                    
                    {comboData && comboData.data && comboData.data.map((product, index)=>( 
                     <div class="col-xl-3 col-lg-3 col-md-6 col-6 pr-lg-4 mb-6">
                        <div class="product-wrap sm-item">
                            <div class="product text-center">
                                <figure class="product-media">
                                    <a href={`/combo-offers?id=${product.comboId}`}>
                                        <img src={`https://demo.sninfoserv.com/api/combo/images/${product.comboImage}`} alt={product.comboPack} width="300" height="338" />
                                        
                                    </a>
                                    <div class="product-action-vertical">
                                        <a href={`/combo-offers?id=${product.comboId}`} class="btn-product-icon w-icon-cart"
                                            title="Add to cart"></a>
                                        <a href="#" class="btn-product-icon btn-wishlist w-icon-heart"
                                            title="Add to wishlist"></a>
                                        <a href="#" class="btn-product-icon btn-quickview w-icon-search"
                                            title="Quickview"></a>
                                        <a href="#" class="btn-product-icon btn-compare w-icon-compare"
                                            title="Add to Compare"></a>
                                    </div>
                                   
                                </figure>
                                <div class="product-details">
                                    <h4 class="product-name"><a href={`/combo-offers?id=${product.comboId}`}>{product.comboPack}</a></h4>
                                     
                                    <div class="product-price">
                                        <ins class="new-price">{currencySymbol} {Number(parseFloat(product.comboPrice) / currencyValue).toFixed(2)}</ins>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                        ))}
                </div>
            </div>
        </div>

        </main>
        <Footer />
    
</div>
  );
}

export default App;
